import {NavLink, useLocation} from 'react-router-dom';
import styles from './index.module.less';
import Icon, {type IconName} from '@/components/common/Icon';
import {useTracking} from '@/services/tracking/context';

interface NavItem {
    key: string;
    label: string;
    icon: IconName;
    activeIcon: IconName;
    path: string;
}

const navItems: NavItem[] = [
    {
        key: 'create',
        label: '创作',
        icon: 'AijBasicChuangzuo',
        activeIcon: 'AijBasicChuangzuoxuanzhong',
        path: '/',
    },
    {
        key: 'asset',
        label: '资产',
        icon: 'AijBasicZichan',
        activeIcon: 'AijBasicZichanxuanzhong',
        path: '/asset?from=asset_tab',
    },
];

const NAV_VALUE_MAP: Record<string, string> = {
    create: 'create_tab',
    asset: 'asset_tab',
};

const NavIcon: React.FC<{item: NavItem; onClick?: () => void}> = ({item, onClick}) => (
    <NavLink
        to={item.path}
        className={({isActive}) => `${styles.navItem} ${isActive ? styles.navItemActive : ''}`}
        onClick={onClick}
    >
        {({isActive}) => (
            <>
                <div className={styles.navIconWrap}>
                    <Icon name={isActive ? item.activeIcon : item.icon} size={20} />
                </div>
                <span className={styles.navLabel}>{item.label}</span>
            </>
        )}
    </NavLink>
);

const Menu: React.FC = () => {
    const {sendClickLog} = useTracking();
    const {pathname} = useLocation();

    const handleNavClick = (item: NavItem) => {
        const targetPath = item.path.split('?')[0];
        if (pathname === targetPath) {
            return;
        }
        const value = NAV_VALUE_MAP[item.key];
        if (value) {
            sendClickLog({value});
        }
    };

    return (
        <div className={styles.pill}>
            <nav className={styles.nav}>
                {navItems.map((item) => (
                    <NavIcon
                        key={item.key}
                        item={item}
                        // eslint-disable-next-line react/jsx-no-bind
                        onClick={() => handleNavClick(item)}
                    />
                ))}
            </nav>
        </div>
    );
};

export default Menu;
